<footer class="footer container my-6 d-flex flex-column align-items-center">
  <div class="d-flex justify-content-between my-6 flex-wrap gap-5 w-100">
    <ul class="footer__nav-list d-flex">
      <li class="footer__nav-list__item">
        <figure class="footer-logo text-start">
          <svg width="250" height="70" viewBox="0 0 390 70" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M54.8613 35.1091C54.8613 13.2422 67.8451 0.393555 89.3007 0.393555C110.756 0.393555 123.47 13.2422 123.47 35.1091C123.47 56.9759 110.351 69.8246 89.3007 69.8246C68.2505 69.8246 54.8613 56.8408 54.8613 35.1091ZM78.0912 35.1091C78.0912 45.0849 80.9641 50.2784 89.1597 50.2784C97.3554 50.2784 100.363 45.0849 100.363 35.1091C100.363 25.1333 97.4964 19.6636 89.1597 19.6636C80.8231 19.6636 78.0912 25.1274 78.0912 35.1091Z"
              fill="white"
            />
            <path
              d="M126.178 49.3385L146.811 45.1026C148.315 51.3889 152.275 53.5744 157.744 53.5744C162.115 53.5744 164.301 52.3465 164.442 49.4736C164.442 46.8768 162.938 45.1026 152.004 42.6409C133.557 38.2699 127.541 32.53 127.541 20.7741C127.541 7.37903 136.97 0 156.652 0C176.333 0 183.165 7.51416 185.216 18.7237L164.718 22.9596C163.76 17.7661 161.71 15.4454 156.111 15.4454C151.599 15.4454 149.413 16.8143 149.413 19.4111C149.413 21.8727 150.23 23.9231 161.164 26.3789C182.619 31.1611 186.72 38.405 186.72 48.3808C186.72 61.7759 177.837 69.4252 157.198 69.4252C133.827 69.4252 127.541 60.407 126.178 49.3326"
              fill="white"
            />
            <path
              d="M234.255 2.05615V20.0984H219.356V41.9652C219.356 45.7898 220.725 47.57 225.231 47.57C227.828 47.57 231.106 46.6123 232.886 46.066L235.348 66.8401C230.019 68.4792 226.876 69.4368 218.951 69.4368C202.689 69.4368 196.126 58.7795 196.126 46.2011V20.0984H189.429V2.05615H234.255Z"
              fill="white"
            />
            <path
              d="M238.127 37.0185C238.127 13.9237 250.153 0.393555 272.29 0.393555C292.929 0.393555 302.218 12.2846 302.218 30.1858C302.218 33.3289 302.218 35.7906 301.806 39.204H260.946C261.768 48.2221 265.181 51.3653 272.014 51.3653C278.847 51.3653 280.762 48.2221 281.99 44.6677L301.395 49.8613C298.522 60.5244 291.419 69.8129 271.873 69.8129C252.327 69.8129 238.115 59.4258 238.115 37.0126M260.946 30.3268H281.038C281.308 21.4438 278.03 17.4781 271.609 17.4781C265.187 17.4781 261.633 20.7564 260.946 30.3268Z"
              fill="white"
            />
            <path
              d="M306.635 67.5865V2.26207H328.502V25.2217H330.417C335.199 4.17733 339.846 1.58057 347.36 1.58057H349V28.3648H344.629C332.191 28.3648 329.87 30.9616 329.87 40.5261V67.5865H306.635Z"
              fill="white"
            />
            <path
              d="M23.2475 20.1394H53.8094V2.00903H0V67.7682H23.2475V53.8914C23.2475 49.5086 25.3801 47.7167 28.5115 46.9823C31.3198 46.3302 44.7148 46.1422 46.1777 46.1246V30.3208L42.5998 30.3443C27.8594 30.215 24.4342 44.3973 24.4342 44.3973H23.2475V20.1394Z"
              fill="white"
            />
            <path
              d="M389.817 48.4143C389.817 59.6855 380.68 68.8226 369.408 68.8226C358.137 68.8226 349 59.6855 349 48.4143C349 37.143 358.137 28.0059 369.408 28.0059C380.68 28.0059 389.817 37.143 389.817 48.4143Z"
              fill="#F8DB69"
            />
          </svg>

          <span class="footer-logo__payoff mt-2 fs-body-md">
            {{ 'footer:payoff-tekst' | fromDictionary }}
          </span>
        </figure>
      </li>
    </ul>

    <ul class="footer__nav-list gap-2 gap-md-4 d-flex text-start flex-column">
      <li class="footer__nav-list__item">
        <span>
          @let email = 'mailto:' + ('footer:emailadres' | fromDictionary);
          <a [href]="email" [trackLinkClick]="email" [trackContext]="'footer-email'">
            {{ 'footer:emailadres' | fromDictionary }}
          </a>
        </span>

        <span>
          @let phone = 'tel:' + ('footer:telefoonnummer' | fromDictionary);
          <a [href]="phone" [trackLinkClick]="phone" trackContext="footer-phone">
            {{ 'footer:telefoonnummer' | fromDictionary }}
          </a>
        </span>
      </li>

      <li class="footer__nav-list__item footer__nav-list__address">
        <span class="d-block text-pre-line">{{ 'footer:adresgegevens' | fromDictionary }}</span>
      </li>
    </ul>
    <ul class="footer__nav-list d-flex">
      <li class="footer__nav-list__item gap-2">
        <span>{{ 'footer:socials-label-tekst' | fromDictionary }}</span>

        <div class="d-flex text-accent mt-0 mt-md-3 gap-3">
          <app-social-channel-buttons [channels]="socials()" [context]="'footer-socials'"></app-social-channel-buttons>
        </div>
      </li>
    </ul>
  </div>
  <a
    href="mailto:hallo@teamfoster.nl"
    class="text-decoration-none footer-big-text-link"
    trackLinkClick="mailto:hallo@teamfoster.nl"
    trackContext="footer-big-email"
  >
    <h2 class="footer-big-text my-3 text-start text-md-center text-nowrap">{{ 'footer:emailadres' | fromDictionary }}</h2>
  </a>

  <div class="d-flex justify-content-start justify-content-md-center gap-3 flex-wrap">
    <span>{{ year }} &copy; {{ 'meta:titel-suffix' | fromDictionary }}</span>

    <ul class="d-flex justify-content-start justify-content-md-center gap-3 flex-wrap">
      <li>
        <button (click)="openCookie()" class="text-accent">{{ 'cookie:settings' | fromDictionary }}</button>
      </li>
      @for (page of metaMenu(); track $index) {
        <li>
          <fstr-link
            [button]="{
              text: page.title,
              url: page.url || '',
              queryParams: page.queryParams || null,
              routerLink: page.routerLink || null,
              fragment: page.fragment || null,
            }"
            [routerLinkActive]="'text-decoration-underline'"
            [showText]="false"
            [cssClasses]="'footer-meta-link'"
          >
            <span>{{ page.title }}</span>
          </fstr-link>
        </li>
      }
    </ul>
  </div>
</footer>
